export const titleOptionList = [
    {
        label: "Select",
        value: ""
    },
    {
        label: "Mr",
        value: "Mr"
    },
    {
        label: "Mrs",
        value: "Mrs"
    },
    {
        label: "Ms",
        value: "Ms"
    },
    {
        label: "Miss",
        value: "Miss"
    },
    {
        label: "Master",
        value: "Master"
    },
    {
        label: "Dr",
        value: "Dr"
    }
];

export const timeOptionList = [
    {
        label: "Anytime",
        value: "Anytime"
    },
    {
        label: "8:30AM to 11:30AM",
        value: "8:30AM to 11:30AM"
    },
    {
        label: "11:30AM to 1:30PM",
        value: "11:30AM to 1:30PM"
    },
    {
        label: "1:30PM to 5:00PM",
        value: "1:30PM to 5:00PM"
    },
    {
        label: "5:00PM to 7:00PM",
        value: "5:00PM to 7:00PM"
    }
];

const SetupData = [
    {
        id: 1,
        params: "info",
        mainLabel: "Let's set up your application!",
        questionLabel: "Is Applicant 1 a gender, age year old smoker?",
        controlTypeId: 4,
        controlType: "RadioButton",
        questionType: "QuestionList",
        isFinal: false,
        isFinalForChild: false,
        availableQuestionAnswers: [
            {
                displayText: "Yes",
                value: "true"
            },
            {
                displayText: "No",
                value: "false"
            }
        ]
    },
    {
        id: 2,
        params: "gender",
        mainLabel: "",
        questionLabel: "What is applicant's gender from birth",
        controlTypeId: 4,
        controlType: "RadioButton",
        questionType: "QuestionList",
        availableQuestionAnswers: [
            {
                displayText: "Male",
                value: "1"
            },
            {
                displayText: "Female",
                value: "2"
            }
        ]
    },
    {
        id: 3,
        params: "smoked",
        mainLabel: "",
        questionLabel: "Has applicant smoked in the past 12 months?",
        controlTypeId: 4,
        controlType: "RadioButton",
        questionType: "QuestionList",
        availableQuestionAnswers: [
            {
                displayText: "Yes",
                value: "true"
            },
            {
                displayText: "No",
                value: "false"
            }
        ]
    },
    {
        id: 4,
        params: "personal",
        mainLabel: "",
        questionLabel: "",
        questionType: "QuestionList",
        questionList: [
            {
                id: 6,
                questionType: "QuestionList",
                questionLabel: "What is applicant's title",
                questionText: "Title",
                controlTypeId: 3,
                controlType: "Dropdown",
                placeholder: "Select",
                optionList: titleOptionList,
                required: true
            },
            {
                id: 7,
                questionType: "QuestionList",
                questionLabel: "What is applicant's first name",
                questionText: "First name",
                controlTypeId: 1,
                controlType: "Textfield",
                placeholder: "First name",
                required: true
            },
            {
                id: 8,
                questionType: "QuestionList",
                questionLabel: "What is firstname's middle name",
                questionText: "Middle name",
                controlTypeId: 1,
                controlType: "Textfield",
                placeholder: "Middle name",
                required: false
            },
            {
                id: 9,
                questionType: "QuestionList",
                questionLabel: "What is firstname's last name",
                questionText: "Last name",
                controlTypeId: 1,
                controlType: "Textfield",
                placeholder: "Last name",
                required: true
            }
        ]
    },
    {
        id: 5,
        params: "dateofbirth",
        mainLabel: "",
        questionLabel: "What is firstname's date of birth",
        controlTypeId: 13,
        controlType: "DateOfBirth",
        isFinal: false,
        isFinalForChild: true,
        dateFormat: "dd MMM yyyy",
        questionType: "QuestionList",
        rangeStart: 16,
        rangeEnd: 75
    },
    {
        id: 10,
        params: "contact",
        mainLabel: "",
        questionLabel: "",
        questionType: "QuestionList",
        isFinal: true,
        isFinalForChild: true,
        questionList: [
            {
                id: 11,
                questionType: "QuestionList",
                questionLabel: "What are firstname's best contact details",
                questionText: "Email address",
                controlTypeId: 17,
                controlType: "EmailAddress",
                placeholder: "Email address",
                required: true
            },
            {
                id: 12,
                questionType: "QuestionList",
                questionLabel: "What are firstname's best contact details",
                questionText: "Phone number",
                controlTypeId: 18,
                controlType: "PhoneNumber",
                placeholder: "Phone number",
                required: true
            },
            {
                id: 13,
                questionType: "QuestionList",
                questionLabel: "What are firstname's best contact details",
                questionText: "Best time to be contacted",
                controlTypeId: 3,
                controlType: "Dropdown",
                placeholder: "Select",
                optionList: timeOptionList,
                required: false,
                answer: "Anytime"
            }
        ]
    }
];

export default SetupData;
